document.addEventListener('DOMContentLoaded', function () {
  const cartGiftOptionDrawer = document.querySelector('cart-gift-option-drawer');
  const closeGiftDrawerButton = document.getElementById('close-gift-drawer');
  const cancelGiftDrawerIcon = document.getElementById('cancel-gift-drawer-icon');
  let filterGroupId = null; // when opening via "edit" on a specific line

  // Delegated click handler for buttons that open the gift-option drawer
  document.addEventListener('click', function (event) {
    const editBtn = event.target.closest('.cart-item__gift_box-edit-button-option')
    const openBtn = event.target.closest('#open-gift-option-drawer')
    if (editBtn) {
      const cartItem = editBtn.closest('.cart-item')
      filterGroupId = cartItem?.dataset?.groupId || null
      openDrawer()
    } else if (openBtn) {
      filterGroupId = null
      openDrawer()
    }
  })

  async function fetchGiftBoxCartItemsAndTotalPrice(itemsUrl, priceUrl) {
    try {
      // Fetch gift box cart items
      const itemsResponse = await fetch(itemsUrl);
      if (!itemsResponse.ok) {
        throw new Error(`HTTP Error! status: ${itemsResponse.status}`);
      }
      const itemsData = await itemsResponse.text();
      let htmlMarkup = new DOMParser()
        .parseFromString(itemsData, 'text/html')
        .querySelector('#shopify-section-cart-gift-option-drawer').innerHTML;
      let giftProdItems = document.querySelector('#gift-drawer-cart-items');
      giftProdItems.innerHTML = htmlMarkup;

      // Fetch cart total price
      const priceResponse = await fetch(priceUrl);
      if (!priceResponse.ok) {
        throw new Error(`HTTP Error! status: ${priceResponse.status}`);
      }
      const priceData = await priceResponse.text();
      let totalPriceElement = new DOMParser()
        .parseFromString(priceData, 'text/html')
        .querySelector('#shopify-section-cart-gift-option-footer').innerHTML;
      let cartTotalPrice = document.querySelector('#gift-drawer-cart-footer-total');
      cartTotalPrice.innerHTML = totalPriceElement;

      return { itemsData, priceData };
    } catch (error) {
      console.warn('Error fetching the API');
      throw error;
    }
  }

  function primeGiftItemsUI() {
    const giftDrawerItems = document.querySelectorAll(
      ".cart-gift-drawer-items"
    );
    if (giftDrawerItems.length === 0) return;

    giftDrawerItems.forEach((item) => {
      // Hide non-target items when editing a specific line
      if (filterGroupId && String(item.dataset.groupId) !== String(filterGroupId)) {
        item.classList.add('hidden');
        return;
      }
      const giftTextArea = item.querySelector(
        ".cart-gifting-drawer-textarea"
      );
      const giftCheckbox = item.querySelector(
        ".gifting-drawer-checkbox-input"
      );
      const giftItemExists = item.dataset.giftItemExist;

      if (giftTextArea) {
        giftTextArea.disabled = false;
      }
      if (giftCheckbox) {
        giftCheckbox.checked = true;
      }

      const desiredAction = giftItemExists === 'true' ? 'update' : 'add';
      item.setAttribute('data-item-cart-action', desiredAction);
    });

    const saveBtn = document.querySelector('#cart-gift-box-save-btn');
    const errorContainer = document.querySelector('#gift-drawer-error-message');
    if (saveBtn) saveBtn.removeAttribute('disabled');
    if (errorContainer) errorContainer.style.display = 'none';
  }

  openDrawer = async () => {
    cartGiftOptionDrawer.classList.add("open");
    addOverflowScroll();
    const giftCartItemsUrl = new URL(window.location);
    giftCartItemsUrl.searchParams.append(
      "section_id",
      "cart-gift-option-drawer"
    );
    const urlString = giftCartItemsUrl.toString();
    giftCartItemsUrl.searchParams.append(
      "section_id",
      "cart-gift-option-footer"
    );
    const urlPriceString = giftCartItemsUrl.toString();
    try {
      await fetchGiftBoxCartItemsAndTotalPrice(urlString, urlPriceString);
      // Run priming immediately after content injection
      primeGiftItemsUI();
    } catch (e) {
      // ignore here; error already logged in fetch function
    }

    // Checks if Gift Drawer is open and hides cart items that do not have a gift item added.
    // Checks against data.gift.item.exist === false
    if (cartGiftOptionDrawer.classList.contains("open")) {
      const observer = new MutationObserver(() => {
        const giftDrawerItems = document.querySelectorAll(
          ".cart-gift-drawer-items"
        );
        if (giftDrawerItems.length > 0) {
          giftDrawerItems.forEach((item) => {
            const giftItemExists = item.dataset.giftItemExist;
            // Hide items not matching the group being edited, if any
            if (filterGroupId && String(item.dataset.groupId) !== String(filterGroupId)) {
              item.classList.add('hidden');
              return;
            }
            if (!giftItemExists || giftItemExists === "false") {
              item.classList.add("hidden");
            }
          });
          // As a fallback, also prime after observer fires
          primeGiftItemsUI();
          observer.disconnect();
        }
      });

      observer.observe(cartGiftOptionDrawer, {
        childList: true,
        subtree: true,
      });
    }
  }

  closeDrawer = () => {
    cartGiftOptionDrawer.classList.remove('open');
    removeOverflowScroll();
    filterGroupId = null;
  }

  addOverflowScroll = () => {
    document.body.classList.add('overflow-hidden--drawer-open');
    document.documentElement.classList.add('overflow-hidden--drawer-open');
  }

  removeOverflowScroll = () => {
    document.body.classList.remove('overflow-hidden--drawer-open');
    document.documentElement.classList.remove('overflow-hidden--drawer-open');
  }

  const giftOptionOverlay = document.getElementById('GiftOption-Overlay');

  if (giftOptionOverlay && cartGiftOptionDrawer) {
    giftOptionOverlay.addEventListener('click', function () {
      closeDrawer();
    });
  }

  if (closeGiftDrawerButton) {
    closeGiftDrawerButton.addEventListener('click', closeDrawer);
  }

  if (cancelGiftDrawerIcon) {
    cancelGiftDrawerIcon.addEventListener('click', closeDrawer);
  }
});
